module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-8.97edd5ea.svg";